export enum IceHockeySuspensionOverAttribute {
  FivePlayers = 477,
  FourPlayers = 478,
  ThreePlayers = 479,
  NoPowerPlay = 817,
}
